import ApiRequest from '@/plugins/axios'
import AuthAPI from '@/api/auth'
import { router } from '@/plugins/vue-router'
import { ToolboxRegistry } from '@naffto/vuetify-helpers/src/entry'

// initial state
const state = {
  isLoggedIn: false,
  identity: {},
  userRights: []
}

// getters
const getters = {
  getIdentity (state) {
    return state.identity
  },
  checkPermissions (state) {
    return (permissionName) => {
      if (!state.identity) {
        return false
      }

      return state.identity.permissions[permissionName]
    }
  },
  isLoggedIn (state) {
    return state.isLoggedIn
  },
  getSessionId (state) {
    return localStorage.getItem('auth.session_id')
  },
  getRights (state) {
    return state.userRights
  }
}

// actions
const actions = {
  async login (store, data) {
    let response

    try {
      response = await AuthAPI.login(data)
    } catch (error) {
      this._vm.$alert.error(error.response.data.error)
      throw error
    }

    store.commit('setAuthentication', response)
    this._vm.$alert.success('Login erfolgreich')
    router.push({ name: 'dashboard.index' })

    return response
  },
  logout (store) {
    store.commit('setAuthentication', {})
    ToolboxRegistry.closeAll()
    router.push({ name: 'auth.login' })
    this._vm.$alert.success('Logout erfolgreich')
  },
  sessionLogout (store) {
    if (!store.state.isLoggedIn) {
      return
    }

    store.commit('setAuthentication', {})
    ToolboxRegistry.closeAll()
    router.push({ name: 'auth.login' })
    this._vm.$alert.success('Logout aufgrund zu langer Inaktivität')
  },
  setIdentity (store, data) {
    store.commit('setIdentity', data)
  },
  async checkLoginStatus (store) {
    if (!localStorage.getItem('auth.session_id')) {
      return
    }

    let response
    try {
      response = await AuthAPI.getRemainingSessionTime(localStorage.getItem('auth.session_id'))
    } catch (err) {
      store.dispatch('sessionLogout')
      return false
    }
    if (response.timeout <= 0) {
      // @todo show login modal?
      store.dispatch('sessionLogout')
      // router.push({ name: 'auth.login' })
    }
    // router.push({ name: 'dashboard.index' })

    return response
  },
  async tryToResumeSession (store) {
    if (!localStorage.getItem('auth.session_id')) {
      return
    }

    let response
    try {
      response = await AuthAPI.status(localStorage.getItem('auth.session_id'))
    } catch (err) {
      // fail silently
      return false
    }

    store.commit('setAuthentication', response)
    router.push({ name: 'dashboard.index' })

    return response
  }
}

// mutations
const mutations = {
  setAuthentication (state, authResponse) {
    state.isLoggedIn = authResponse.success ? authResponse.success : false

    // set auth header for next requests
    if (authResponse.session) {
      ApiRequest.defaults.headers.common['X-Session-Id'] = authResponse.session
      // add session to local storage
      localStorage.setItem('auth.session_id', authResponse.session)
    } else {
      delete ApiRequest.defaults.headers.common['X-Session-Id']
      localStorage.removeItem('auth.session_id')
    }

    state.identity = authResponse.identity ? authResponse.identity : {}
    state.userRights = authResponse.rights
  },
  setIdentity (state, payload) {
    state.identity = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
